import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { useApolloClient } from '@apollo/client';
import MenuItem from '@material-ui/core/MenuItem';
import SnackbarContext from '../../../containers/CustomSnackbar/SnackbarContext';
import RESET_SUBSCRIPTION_SWITCH_COUNT from '../../../graphql/user/mutation/reset-subscription-switch-count';

const ConfirmResetSwitchLimit = ({ _id, closeMenu }) => {
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
    closeMenu();
  }

  const client = useApolloClient();

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <Typography variant="body1" color="textSecondary">
          Reset Switch Limit
        </Typography>
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="reset-switch-dialog-title"
      >
        <DialogTitle id="reset-switch-dialog-title">
          Reset Subscription Switch Limit?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will reset the user's subscription switch count to 0, allowing
            them to switch between Gym and Studio again. This action can only be
            performed by admins.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <SnackbarContext.Consumer>
            {(value) => (
              <Button
                onClick={() => {
                  client.mutate({
                    mutation: RESET_SUBSCRIPTION_SWITCH_COUNT,
                    variables: { _id },
                  })
                    .then(() => {
                      value.openSnackbar('success', 'Subscription switch count reset successfully');
                      handleClose();
                    })
                    .catch((error) => {
                      console.log(error);
                      value.openSnackbar('error', error?.message || 'Could not reset switch limit');
                      handleClose();
                    });
                }}
                color="primary"
                variant="contained"
              >
                Reset
              </Button>
            )}
          </SnackbarContext.Consumer>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmResetSwitchLimit;
